import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RegistrationPendingContractRoute extends Route {
  @service segment;

  beforeModel() {
    this.segment.track('onboarding_partner_pending_contract_displayed');
  }

  model() {
    return this.modelFor('registration');
  }
}
